export const PLAY_STORE_URL = "https://betheshyft.app.link/9Jhf6s5CRub";
export const APPLE_STORE_URL = "https://betheshyft.app.link/9Jhf6s5CRub";
export const DUAL_STORE_LINK = "https://mindhouse.app.link";
export const HOME_LINK = "/";
